module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"browser_title":"MEMBERSHIP AGREEMENT","agreement":"Membership Agreement"},"ja":{"browser_title":"利用規約","agreement":"利用規約"}}')
  delete Component.options._Ctor
}
